import Papa from "papaparse";
import { identity, pathOr } from "ramda";
import Big from "big.js";

const formatFn = (headers, format) => object =>
  headers.map(key =>
    (format[key] || identity)(pathOr(null, key.split("."), object))
  );

export default async ({ headers, query, format = {} }, flag = false) => {
  const data = [];
  const formatter = formatFn(Object.keys(headers), format);

  const result = await query(object => {
    if ((object.tips || object.total_adding_optional) && !flag) {
      object.revenues = Big(object.revenues)
        .plus(object.tips || 0)
        .plus(object.total_adding_optional || 0);
      object.profit = Big(object.profit)
        .plus(object.tips || 0)
        .plus(object.total_adding_optional || 0);

      return data.push(formatter(object));
    }

    return data.push(formatter(object));
  });

  if (!result) {
    return { success: false };
  }

  const fields = Object.values(headers);

  return {
    success: true,
    data: Papa.unparse({ data, fields })
  };
};



// WEBPACK FOOTER //
// ./src/util/csv-from-stream.js